enum RoleGroupEnum {
  APPRAISER = 'appraiser',
  CALLCENTER = 'callcenter',
  CAR_DEALER = 'carDealer',
  CAR_RENTAL = 'carRental',
  DAMAGE_SERVICE_PROVIDER = 'damageServiceProvider',
  EXTERNAL_SERVICE_PROVIDER = 'externalServiceProvider',
  FLEET_MANAGER = 'fleetManager',
  LAW_OFFICE = 'lawOffice',
  RESELLER = 'reseller',
}

export default RoleGroupEnum;
